import React, { useState } from 'react';
import { Navbar as BootstrapNavbar, Nav } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useLogout } from '../../Hooks/useLogout';
import useUserStore from '../../Stores/UserStore';

import { FaShoppingCart, FaUserCircle } from 'react-icons/fa';
import { LuLogOut } from 'react-icons/lu';
import { RiUserSettingsLine } from 'react-icons/ri';
import BellIcon from '../../assets/images/notification-icon.svg?react';
import LogoutModal from '../LogoutModal/LogoutModal';

import { FaRegMessage } from 'react-icons/fa6';
import logo from '../../assets/images/logo.png';
import CustomButton from '../CustomButton';
import TableActionDropDown from '../TableActionDropDown/TableActionDropDown';
import './Header.css';
import { HiQuestionMarkCircle } from 'react-icons/hi';
const Header = ({ variant = 'default' }) => {
  const navigate = useNavigate();
  const { user, role = 'guest' } = useUserStore();
  const isAuthenticated = !!user;
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const logoutMutation = useLogout();

  const getInitials = (name = '') => {
    return name
      ?.split(' ')
      ?.map((word) => word?.[0]?.toUpperCase())
      ?.join('');
  };

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleLogout = () => {
    logoutMutation.mutate(role);
    setShowLogoutModal(false);
  };
  const navigationItems = [
    { label: 'Home', link: '/' },
    { label: 'About Us', link: '/about-us' },
    { label: 'Contact Us', link: '/help-center' },
  ];

  const authenticatedNavItems = [
    { label: 'Home', link: '/home' },
    { label: 'Gift Shop', link: '/gift-store' },
    { label: 'Coins Store', link: '/coin-store' },
    { label: 'Subscription Plans', link: '/subscription-plans' },
    { label: 'About Us', link: '/about-us' },
    { label: 'Contact Us', link: '/help-center' },
  ];

  return (
    <BootstrapNavbar
      className={`mainHeaderBar site-header-nav ${variant}`}
      expand="lg"
      variant="light"
    >
      <div className="header-main-container">
        {/* Logo/Brand */}
        <BootstrapNavbar.Brand as={Link} to="/" className="navbar-brand">
          <img src={logo} alt="" width={100} />
        </BootstrapNavbar.Brand>

        <BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />

        <BootstrapNavbar.Collapse id="basic-navbar-nav">
          {/* Navigation Menu */}
          <Nav className="mx-auto gap-4">
            {(isAuthenticated ? authenticatedNavItems : navigationItems).map(
              (item, index) => (
                <Nav.Link
                  key={index}
                  as={Link}
                  to={item.link}
                  className="nav-link"
                >
                  {item.icon && <item.icon className="nav-icon" />}
                  {item.label}
                </Nav.Link>
              )
            )}
          </Nav>

          {/* Right Side Actions */}
          <div className="d-flex gap-2 gap-sm-3 align-items-center">
            {isAuthenticated ? (
              <>
                {/* Support Button for non-admin users */}
                {role !== 'admin' && (
                  <div className="d-flex gap-3">
                    <button className='transparent-btn' style={{ fontSize: '20px' }}><FaRegMessage /></button>
                    <button className='transparent-btn' onClick={() => navigate('/notifications')}><BellIcon /></button>
                  </div>
                )}



                {/* User Dropdown */}
                <TableActionDropDown
                  actions={[
                    {
                      name: 'My Profile',
                      icon: 'profile',
                      onClick: () => {
                        if (user?.role === 'admin') {
                          navigate('/admin/profile');
                        } else {
                          navigate('/profile');
                        }
                      },
                    },
                    {
                      name: 'Blocked Users',
                      icon: 'block-list',
                      onClick: () => {
                        navigate('/blocked-users');
                      },
                    },
                    {
                      name: 'Refer a Friend',
                      icon: 'refer-a-friend',
                      onClick: () => {
                        navigate('/refer-a-friend');
                      },
                    },
                    {
                      name: 'Settings', 
                      icon: 'settings',
                      onClick: () => {
                        navigate('/settings');
                      },
                    },
                    {
                      name: 'Help Center',
                      icon: 'help-center',
                      onClick: () => {
                        navigate('/help-center');
                      },
                    },
                    {
                      name: 'Logout',
                      icon: 'logout',
                      onClick: handleLogoutClick,
                    },
                  ]}
                >
                  <div className="userImage gap-1 beechMein">
                    {user?.image ? (
                      <img src={user?.image} alt="" className="img-fluid profile-pic" />
                    ) : (
                      <FaUserCircle size={30} />
                    )}
                    <h6>{user?.full_name}</h6>
                  </div>
                </TableActionDropDown>
              </>
            ) : (
              <>
                {/* Guest User Actions */}
                <CustomButton
                  onClick={() => navigate('/signup')}
                  className="d-none d-sm-block"
                >
                  Register
                </CustomButton>
                <CustomButton
                  onClick={() => navigate('/login')}
                  variant="secondaryButton"
                  className="d-none d-sm-block"
                >
                  Login
                </CustomButton>
              </>
            )}
          </div>
        </BootstrapNavbar.Collapse>
      </div>
      {/* Logout Modal */}
      <LogoutModal
        show={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onLogout={handleLogout}
        isLoading={logoutMutation.isPending}
      />
    </BootstrapNavbar>
  );
};

export default Header;
